import axiosIns from "@/api/axios";

export const GET_NOTIFICATION_EVENTS = (query) => {
  let url = "/notification-events";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_NOTIFICATION_EVENT_DETAIL = (id) => {
  return axiosIns.get(`/notification-events/${id}`);
};

export const CREATE_NOTIFICATION_EVENT = (data) => {
  return axiosIns.post("/notification-events", data);
};

export const UPDATE_NOTIFICATION_EVENT = ({ id, data }) => {
  return axiosIns.put(`/notification-events/${id}`, data);
};

export const DELETE_NOTIFICATION_EVENT = (id) => {
  return axiosIns.delete(`/notification-events/${id}`);
};

export const DUPLICATE_NOTIFICATION_EVENT = (id) => {
  return axiosIns.get(`/notification-events/${id}/duplicate`);
};

export const GET_NOTIFICATION_TRIGGERS = () => {
  return axiosIns.get(`/notification-triggers?all=true&field=name&order=asc`);
};

export const GET_NOTIFICATION_RECIPIENTS = () => {
  return axiosIns.get(`/notification-events/recipients`);
};

export const GET_MODULE_TYPES = () => {
  return axiosIns.get(`/module-types?all=true`);
};
